export default __webpack_public_path__ + "i18n/translations/translation-ml.f111f5f5.json";